import { jsx as _jsx } from "react/jsx-runtime";
import { FootballSchoolStaffDesktopCard, FootballSchoolStaffMobileCard } from "@nitra/nkmb-card-components/cards";
import { useIsMobileContext } from "@nitra/nkmb-card-components/contexts";
export function FootballSchoolStaffCard(props) {
    var isMobile = useIsMobileContext();
    if (isMobile) {
        return _jsx(FootballSchoolStaffMobileCard, { staff: props.staff });
    }
    else {
        return _jsx(FootballSchoolStaffDesktopCard, { staff: props.staff });
    }
}
